import {AnyAction, Reducer} from 'redux';
import {Polls, StoreActionsEnum} from '../../../modules/hbs-services';

export const pollsReducer: Reducer<Polls> = (state = null, action: AnyAction = null) => {

    switch (action.type) {

        case StoreActionsEnum.POLLS_LOADED:
            return {
                ...state,
                polls: action.payload.records
            };

        default:
            return state;
    }
};
